import { createFileRoute, redirect } from '@tanstack/react-router';

import { isPersonAdmin } from 'helpers/query';

export const newUserModalValues = ['company-add'] as const;

export type NewUserModal = (typeof newUserModalValues)[number];

function coerceNewUserModal(value: unknown): NewUserModal | undefined {
  if (value === 'company-add') {
    return value;
  }
  return undefined;
}

export type NewUserSearch = {
  // The person the new login is for, when opened from their Accounts tab.
  identity?: string;
  modal?: NewUserModal;
};

/** Coerces known search keys; unknown query params are dropped for this route. */
export function parseNewUserSearch(
  search: Record<string, unknown>,
): NewUserSearch {
  return {
    identity:
      typeof search.identity === 'string' && search.identity
        ? search.identity
        : undefined,
    modal: coerceNewUserModal(search.modal),
  };
}

export const Route = createFileRoute('/_private/_route/users/new/')({
  beforeLoad: ({ context }) => {
    if (!isPersonAdmin(context.user)) {
      throw redirect({ replace: true, to: '/' });
    }
  },
  validateSearch: parseNewUserSearch,
});
